import { RootState } from '../index';
import { isInsertingANonStructuralGable } from './profileSelectors';

export function getActiveWebbingInfo(state: RootState) {
  if (state.application.insertingObjectInfo?.type === 'componentDesign') {
    if (state.application.insertingObjectInfo.stage !== 'StructuralDetails') return null;
    if (isInsertingANonStructuralGable(state)) return null;

    return state.application.insertingObjectInfo.webbingInfo;
  }

  return state.application.rewebbingInfo?.webbingInfo ?? null;
}
